import { apiFetch } from './utils/api';

export const investmentStrategyPortfolioCharacteristics = {
  /**
   * @desc Get a investment strategy's products
   *
   * @return json - data or error message
   */
  get: async (args = {}) => {
    const options = {
      method: 'GET',
    };

    if (!args.strategyId) {
      throw new Error('Strategy ID required for this API endpoint');
    }

    const url = `/v3/investment-strategies/${args.strategyId}/portfolio-characteristics`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
